import { MallInput } from "@saleor/types/globalTypes";

export function getFilterVariables(_params?: any): MallInput {
  return {};
}

export enum TabValuesEnum {
  TEMPLATES = "TEMPLATES",
  TASK_AREA_MANAGEMENT = "TASK_AREA_MANAGEMENT",
  RUNNER_ASSIGNMENT = "RUNNER_ASSIGNMENT"
}
